import _ from "lodash";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { injectIntl } from "react-intl";

import LoginWhatsappAuth from "./containers/login-whatsapp-auth/login-whatsapp-auth";

import {
  types as userTypes,
  actions as userActions,
} from "../../../redux/modules/usuario";
import {
  actions as flowActions,
  selectors as flowSelectors,
} from "../../../redux/modules/flow";
import {
  consts as cfgConsts,
  selectors as cfgSelectors,
} from "../../../redux/modules/configuracoes";
import { TabTitle } from "../../../utils/functions/GeneralFunctions";
import { setWhatsappCelular, getWhatsappCelular } from "../../../utils/functions/whatsappCelular";

// Tela isolada de login acessada a partir de um retorno do ChatIA/OpenClick via WhatsApp.
// Reaproveita os 3 métodos de login já existentes em LoginAuth (gov.br, certificado
// digital e usuário/senha) — não introduz um novo método de autenticação.
class LoginWhatsapp extends PureComponent {
  state = {
    celular: null,
  };

  componentDidMount() {
    const celularDaQuery = new URLSearchParams(window.location.search).get("celular");
    const celular = celularDaQuery || getWhatsappCelular();
    setWhatsappCelular(celular);
    this.setState({ celular });

    const { intl } = this.props;
    const pageTitle = intl.formatMessage({ id: "LABELS.LOGIN_WHATSAPP.TITLE" });
    const systemTitle = intl.formatMessage({ id: "LABELS.COMMONS.NOME_SISTEMA" });
    const clientTitle = intl.formatMessage({ id: "LABELS.COMMONS.NOME_CLIENTE" });
    TabTitle(`${pageTitle} - ${systemTitle} - ${clientTitle}`);
  }

  componentWillUnmount() {
    this.props.reset(userTypes.USER_LOGIN);
  }

  render() {
    const { loading, login, captchaEnabled, captchaSitekey } = this.props;
    const redirectUrl = _.get(this.props, "location.state.redirectUrl");
    sessionStorage.setItem("redirectUrl", redirectUrl);

    return (
      <div className="portal-col__wrapper">
        <LoginWhatsappAuth
          loading={loading}
          login={login}
          redirectUrl={redirectUrl}
          captchaEnabled={captchaEnabled}
          captchaSitekey={captchaSitekey}
          celular={this.state.celular}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    loading: flowSelectors.isLoadingByType(state, userTypes.USER_LOGIN),
    captchaEnabled:
      cfgSelectors
        .getValorConfiguracao(state, cfgConsts.GOOGLE_RECAPTCHA_ENABLED)
        .toUpperCase() === "TRUE",
    captchaSitekey: cfgSelectors.getValorConfiguracao(
      state,
      cfgConsts.GOOGLE_RECAPTCHA_SITE_KEY,
    ),
  };
}

const mapDispatchToProps = {
  login: userActions.loginUser,
  reset: flowActions.reset,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl,
)(LoginWhatsapp);
